import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/dev/Dev.js"
import Audiomix from "@frog/source/engine/Audiomix.js"

import SpriteAnimation from "@frog/source/engine/animating/utility/SpriteAnimation.js"
import "@frog/source/views/components/UnitSprite.less"

import unitSprites from "@frog/source/data/unitSprites.js"
import unitJobs from "@frog/source/data/unitJobs.js"
import games from "@frog/source/data/games/index.js"

const DEFAULT_AFFILIATION = "bad"
const DEFAULT_FACE_KEY = "human"

export default class UnitSprite {
    render() {
        if(this.props.unit == undefined) return

        let sprite = this.getSprite()
        if(sprite == undefined) return

        if(sprite.parts != undefined) {
            return (
                <div class="UnitSprite" key={this.props.unit.key}
                    isGrayscaled={this.props.isGrayscaled}
                    isHighlighted={this.props.isHighlighted}
                    isBlackedOut={this.props.unit?.properties?.includes("blacked out until aggroed") && this.props.unit.state != "aggroed" && this.props.unit.state != "afraid"}
                    isInvisible={this.props.unit.role == "invisible" && Dev.inProtoMode != true} // book
                    animationKey={this.animationKey}
                    affiliation={this.props.unit.affiliation == App.game?.chapter?.stage?.player?.affiliation && "ally"}
                    spriteSize={this.props.unit.spriteSize}
                    style={{
                        "animation-delay": this.animationDelay,
                        "animation-duration": this.animationDuration,
                    }}>
                    {this.getSprite(this.props.unit?.sprites).parts.map((spritepart) => {
                        let image = spritepart.image
                        if(spritepart.animation != undefined) {
                            image = SpriteAnimation.getImage({"animation": spritepart.animation})
                        }
                        return (
                            <div class="SpritePart" type={spritepart.type} style={{
                                "background-image": "url(" + (image ?? "") + ")",
                                "z-index": 1000 - (spritepart.stack || 0),
                            }}/>
                        )
                    })}
                    <div class="Weapon" type="body" style={{
                        "background-image": "url(" + (this.weaponImageUrl() ?? "") + ")",
                        "z-index": 1000,
                    }}/>
                    <div class="Decal" type="body" style={{
                        "background-image": "url(" + (this.decalImageUrl() ?? "") + ")",
                        "z-index": 1000,
                    }}/>
                </div>
            )
        }

        if(sprite.frames != undefined) {
            const currentImage = SpriteAnimation.getImage({"animation": sprite})

            let images = {}
            sprite.frames.forEach((frame) => {
                images[frame.image] = frame.image
            })

            return Object.values(images).map((image) => {
                return (
                    <div class="UnitSprite"
                        isGrayscaled={this.props.isGrayscaled}
                        isHighlighted={this.props.isHighlighted}
                        spriteSize={this.props.unit.spriteSize}
                        animationKey={this.animationKey}
                        style={{
                            "opacity": image == currentImage ? 1 : 0,
                            "background-image": "url(" + image + ")",
                            // "animation-delay": this.animationDelay,
                            // "animation-duration": this.animationDuration,
                        }}/>
                )
            })
        }

        return (
            <div class="UnitSprite" key={this.props.unit.key}
                isGrayscaled={this.props.isGrayscaled}
                isHighlighted={this.props.isHighlighted}
                // isBlackedOut={this.props.unit.decalImageKey == "jail"}
                spriteSize={this.props.unit.spriteSize}
                animationKey={this.animationKey}
                affiliation={this.props.unit.affiliation == App.game?.chapter?.stage?.player?.affiliation && "ally"}
                style={{
                    "background-image": "url(" + (sprite ?? "") + ")",
                    "animation-delay": this.animationDelay,
                    "animation-duration": this.animationDuration,
                }}>
                <div class="Weapon" style={{
                    "background-image": "url(" + (this.weaponImageUrl() ?? "") + ")",
                    // "display": this.props.unit.affiliation == "none" ? "none" : undefined,
                }}/>
                <div class="Decal" type="body" style={{
                    "background-image": "url(" + (this.decalImageUrl() ?? "") + ")",
                    "z-index": 1000,
                }}/>
            </div>
        )

        // return (
        //     <div class="UnitSprite" key={this.props.unit.key}
        //         isGrayscaled={this.props.isGrayscaled}
        //         isHighlighted={this.props.isHighlighted}
        //         animationKey={this.animationKey}
        //         spriteSize={this.props.unit.spriteSize}
        //         style={this.style}>
        //         <div class="Body" style={{
        //             "background-image": this.bodyUrl() && "url(" + this.bodyUrl() + ")",
        //             "animation-name": this.animationKey,
        //             "animation-delay": this.animationDelay,
        //         }}/>
        //         <div class="Face" style={{
        //             "background-image": this.faceUrl() && "url(" + this.faceUrl() + ")",
        //             "animation-name": this.animationKey,
        //             "animation-delay": this.animationDelay,
        //         }}/>
        //         <div class="Decal" style={{
        //             "background-image": this.decalUrl() && "url(" + this.decalUrl() + ")",
        //             "animation-name": this.animationKey,
        //             "animation-delay": this.animationDelay,
        //         }}/>
        //         <div class="Weapon" isHidden={this.props.unit.affiliation == "none"}
        //             isBig={isBig} style={{
        //             "background-image": this.weaponImageUrl() && "url(" + this.weaponImageUrl() + ")",
        //             "animation-name": this.animationKey,
        //             "animation-delay": this.animationDelay,
        //         }}/>
        //     </div>
        // )
    }
    // get animation() {
    //     return {
    //         "animation-name": this.animationKey,
    //         "animation-delay": this.animationDelay,
    //         // "animation-direction": this.animationKey == "squigglevision" && "alternate",
    //         "animation-duration": this.animationKey == "squigglevision" && "0.5s"
    //     }
    // }
    get animationKey() {
        if(App.game.slug == "pirates") {
            if(this.props.unit.properties?.includes("no rockout") == true) {
                return undefined
            }
            return "rockout"
        }
        if(this.props.unit.animationKey != undefined) {
            return this.props.unit.animationKey
        }
        if(App.game?.configuration?.squigglevision == "character"
        && Dev.inProtoMode != true
        && this.props.abortSquigglevision != true) {
            return "squigglevision"
        }
    }
    get animationDuration() {
        if(App.game.slug == "pirates") {
            const bpm = Audiomix.getActiveTriggerByLabel("music")?.bpm ?? 0
            if(bpm == 0) return "0ms"
            return (1000 * 60) / bpm + "ms"
        }
    }
    get animationDelay() {
        if(App.game.slug == "pirates") {
            return 0
        }
        if(this.props.unit.affiliation != "good") {
            return (this.props.index || 0) * -1.1 + "s"
        } else {
            return "-0.5s"
        }
    }
    // bodyUrl() {
    //     if(this.imageUrl != undefined) return
    //     let protoBodyKey = undefined
    //     if(Dev.inProtoMode == true) {
    //         protoBodyKey = this.getUnitProperty("bodyKey")
    //     }
    //     return this.props.unit.body || unitSprites.bodies[protoBodyKey || this.props.unit.bodyKey || this.props.unit.affiliation || DEFAULT_AFFILIATION]
    // }
    // faceUrl() {
    //     if(this.imageUrl != undefined) return
    //     let protoFace = undefined
    //     let protoFaceKey = undefined
    //     if(Dev.inProtoMode == true) {
    //         protoFace = this.getUnitProperty("face")
    //         protoFaceKey = this.getUnitProperty("faceKey")
    //     }
    //     return this.props.unit.face || protoFace || unitSprites.faces[this.props.unit.faceKey || protoFaceKey || DEFAULT_FACE_KEY]
    // }
    decalImageUrl() {
        // if(this.props.unit.affiliation == "none") {
        //     return unitSprites.decals["jail"]
        // }
        if(this.props.unit.decalImageUrl != undefined) {
            return this.props.unit.decalImageUrl
        }
        if(this.props.unit.decalImageKey != undefined) {
            return unitSprites.decals[this.props.unit.decalImageKey]
        }
    }
    weaponImageUrl() {
        if(this.props.unit.weaponImageKey == "hidden") return
        if(this.props.unit.state == "pacified") return
        if(this.props.unit.decalImageKey == "jail") return

        if(this.props.unit.weaponImage) return this.props.unit.weaponImage
        if(this.props.unit.equippedItem?.weaponImage) return this.props.unit.equippedItem.weaponImage

        // let protoWeaponImageKey = undefined
        // if(Dev.inProtoMode == true) {
        //     protoWeaponImageKey = this.getUnitProperty("weaponImageKey") || this.getUnitProperty("primaryItem")?.weaponImageKey
        // }
        return unitSprites.weapons[this.props.unit.weaponImageKey ?? this.props.unit.equippedItem?.weaponImageKey ?? this.props.unit.cachedProperties?.primaryItem?.weaponImageKey]
    }
    // get imageUrl() {
    //     const unit = this.props.unit
    //
    //     if(unit.imageKey != undefined
    //     && unitSprites.images[unit.imageKey] != undefined) {
    //         return unitSprites.images[unit.imageKey]
    //     }
    //
    //     if(unit.spriteKey != undefined
    //     && unit.sprites != undefined
    //     && unit.sprites[unit.spriteKey] != undefined) {
    //         return unit.sprites[unit.spriteKey]
    //     }
    //
    //     if(unit.imageUrl != undefined) return unit.imageUrl
    //
    //     if(unit.sprites == undefined) return
    //
    //     if(unit.affiliation == "good"
    //     && unit.energy != undefined
    //     && unit.energy["invoke skill"] != false) {
    //         if(unit.sprites?.moving != undefined
    //         && App.game?.chapter?.selection?.selectedUnitKey == unit.key) {
    //             return SpriteAnimation.getImage({
    //                 "animation": unit.sprites.moving
    //             })
    //         }
    //
    //         if(unit.sprites?.ready != undefined
    //         && (App.game?.chapter?.selection?.hoveredUnitKey == unit.key
    //         || App.game?.chapter?.selection?.selectedUnitKey == unit.key)) {
    //             return SpriteAnimation.getImage({
    //                 "animation": unit.sprites.ready,
    //                 "startTimestamp": App.game?.chapter?.selection?.hoveredTimestamp
    //             })
    //         }
    //     }
    //
    //     if(unit.sprites?.idle != undefined) {
    //         return SpriteAnimation.getImage({
    //             "animation": unit.sprites.idle
    //         })
    //     }
    //     if(unit.sprites.aggroed != undefined
    //     && unit.state == "aggroed") {
    //         return unit.sprites.aggroed
    //     }
    //     if(unit.sprites.static != undefined) {
    //         return unit.sprites.static
    //     }
    // }

    getSprite() {
        const unit = this.props.unit

        if(unit.imageKey != undefined
        && unitSprites.images[unit.imageKey] != undefined) {
            return unitSprites.images[unit.imageKey]
        }

        if(unit.imageUrl != undefined) {
            return unit.imageUrl
        }

        if(unit.sprites != undefined) {
            if(unit.spriteKey != undefined
            && unit.sprites != undefined
            && unit.sprites[unit.spriteKey] != undefined) {
                return unit.sprites[unit.spriteKey]
            }

            if(unit.affiliation == "good"
            && unit.energy != undefined
            && unit.energy["invoke skill"] != false) {
                if(unit.sprites.moving != undefined
                && App.game?.chapter?.selection?.selectedUnitKey == unit.key) {
                    return unit.sprites.moving
                }

                if(unit.sprites?.ready != undefined
                && (App.game?.chapter?.selection?.hoveredUnitKey == unit.key
                || App.game?.chapter?.selection?.selectedUnitKey == unit.key)) {
                    // TODO: Someday, let the sprite animation ONLY be processed at the render level,
                    // and let this somehow return the bias to start on the hoveredTimestamp?
                    return unit.sprites.ready
                }
            }

            if(unit.state == "aggroed"
            && unit.sprites.aggroed != undefined) {
                return unit.sprites.aggroed
            }
            if(unit.sprites.idle != undefined) {
                return unit.sprites.idle
            }
            if(unit.sprites.static != undefined) {
                return unit.sprites.static
            }
        }
    }
}
